<template>
  <a-layout-content>
    <a-form layout="inline">
      <a-form-item label="会员名称">
        <a-input v-model="input.User" />
      </a-form-item>
      <!-- <a-form-item label="">
        <a-checkbox :checked="input.Sorte">模糊查询</a-checkbox>
      </a-form-item> -->
      <a-form-item label="异常类型">
        <a-select v-model="input.State" style="width: 186px">
          <a-select-option value="0"> -- 全部 --</a-select-option>
          <a-select-option value="1"> 还款订单导入异常会员</a-select-option>
          <a-select-option value="2"> 批量还款成功异常会员</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="query()"
          ><a-icon type="search"
        /></a-button>
      </a-form-item>
    </a-form>
    <br />
    <div class="body-nest" style="ma">
      <a-table
        bordered
        size="middle"
        row-key="ID"
        :columns="columns"
        :data-source="datarow"
        :pagination="pagination"
        @change="changepage"
      >
        <template slot="title">
          <a-row :gutter="24">
            <a-col :span="6" style="line-height: 30px">借还款异常会员列表</a-col>
            <a-col style="float: right">
              <a-button type="primary" icon="download" @click="Export()">
                全部导出
              </a-button>
            </a-col>
          </a-row>
        </template>
        <template slot="state" slot-scope="text">
          <span v-if="text == 1">还款订单导入异常会员</span>
          <span v-if="text == 2">批量还款成功异常会员</span>
        </template>
      </a-table>
    </div>
  </a-layout-content>
</template>
<script>

export default {
  data() {
    return {
      //------table --------
      columns: IninTable(),
      datarow: [],
      pagination: {
        total: 0,
        pageindex: 1,
        pagesize: 10,
        showTotal: (total) => `共 ${total} 条`,
        showSizeChanger: true, // 可以改变每页个数
        pageSizeOptions: ["10", "20", "30", "40"],
        onShowSizeChange: (current, pageSize) => (this.pageSize = pageSize),
      },
      //--------------------
      input: {
        User: "",
        State: "0",
      },
    };
  },
  methods: {
    query() {
      let params = {
        User: this.input.User,
        Status: this.input.State,
        pageindex: this.pagination.pageindex,
        pagesize: this.pagination.pagesize,
      };

      this.axios.post("/BorrowOrder/recordquery", params).then((res) => {
        this.datarow = res.data;
        this.pagination.total = res.total;
      });
    },
    //翻页
    changepage(e) {
      this.pagination.pageindex = e.current;
      this.pagination.pagesize = e.pageSize;
      this.query();
    },
    Export() {
      const _this = this;
      this.$confirm({
        title: "导出",
        content: "确定要导出全部数据吗？",
        onOk() {
          _this.ExportData({});
        },
      });
    },
    //导出
    ExportData(data) {
      let today = new Date();
      this.$message.success(
        "开始执行导出请在停留在页面勿离开,因数据量较多请稍待片刻谢谢"
      );
      this.axios({
        url: "/BorrowOrder/recordqueryexport",
        method: "post",
        params: {},
        responseType: "blob",
      }).then((response) => {
        let blob = new Blob([response.data], { type: response.data.type });
        // 针对于 IE 浏览器的处理, 因部分 IE 浏览器不支持 createObjectURL
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob);
        } else {
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); // 创建下载的链接
          downloadElement.href = href;
          downloadElement.download =
            "借还款调整记录- " + today.toISOString().split("T")[0]; // 下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); // 点击下载
          document.body.removeChild(downloadElement); // 下载完成移除元素
          window.URL.revokeObjectURL(href); // 释放掉 blob 对象
        }
      });
    },
  },
  created() {
    this.query();
  },
};
const IninTable = function IninTable() {
  var header = [];
  header.push({ title: "会员账号", align: "center", dataIndex: "User" });
  header.push({
    title: "状态",
    align: "center",
    dataIndex: "State",
    scopedSlots: { customRender: "state" },
  });
  header.push({ title: "异常差额", align: "center", dataIndex: "DiffAmount" });
  header.push({ title: "总借款", align: "center", dataIndex: "TotalBorrow" });
  header.push({ title: "总还款", align: "center", dataIndex: "TotalRepay" });
  header.push({ title: "时间", align: "center", dataIndex: "Fdt" });
  return header;
};
</script>

<style>
.clearline {
  border-top: solid #acc0d8 1px;
  margin: 10px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/ordermanage/paymentrecord.vue